module.exports = __webpack_public_path__ + "static/img/bet-complete-character.51fa438.png";